import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { auth, db, doc, getDoc } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import Navbar from "./Navbar";
import Home from "./Home";
import Pricing from "./Pricing";
import Login from "./Login";
import Register from "./Register";
import ResetSuccess from "./ResetSuccess";
import Profile from "./Profile";
import PaymentSuccess from "./PaymentSuccess";
import Purchase from "./Purchase";
import Help from "./Help";
import Features from "./Features";
import Blogs from "./Blogs";
import BlogDetail from "./BlogDetail"; // You need to create this
import BlogForm from "./BlogForm";     // Optional, only for admins

import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import CookiePolicy from "./pages/CookiePolicy";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import { FaSpinner } from "react-icons/fa"; // Spinner icon
import './styles/colors.css';
import CookieConsent from "react-cookie-consent";
import CookieConsentDialog from "./components/CookieConsentDialog";
import GeoCookieConsent from "./components/GeoCookieConsent";
import './styles/colors.css';

import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";

function App() {
    const [user, setUser] = useState(null);
    const [userRole, setUserRole] = useState(null);

    const [loading, setLoading] = useState(true); // Track loading state
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY); // your publishable key

    useEffect(() => {
        const unsubscribe =  onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                const userRef = doc(db, "users", currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    setUser({ ...currentUser, type: userSnap.data().type });
                    setUserRole(userSnap.data());

                }
            } else {
                setUser(null);
                setUserRole(null)
            }
            setLoading(false); // Stop loading after checking auth
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <FaSpinner className="spinner" size={50} />
            </div>
        );
    }

    return (
        <Router>
            <div className="app-wrapper">
                <Navbar user={user} />
                <main className="app-content">
                    <Elements stripe={stripePromise}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            {/*<Route path="/" element={user ? <Home /> : <Login />} />*/}
                            <Route path="/pricing" element={<Pricing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/reset-success" element={<ResetSuccess />} />
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/payment-success" element={<PaymentSuccess />}/>
                            <Route path="/purchase" element={<Purchase />} />
                            <Route path="/help" element={<Help />} />
                            <Route path="/features" element={<Features />} />
                            <Route path="/blogs" element={<Blogs />} />
                            <Route path="/privacy" element={<PrivacyPolicy/>} />
                            <Route path="/terms" element={<TermsOfUse />} />
                            <Route path="/cookie-policy" element={<CookiePolicy />} />

                            <Route path="/create" element={<BlogForm />} /> {/* Optional */}
                            <Route path="/blogs/:id" element={<BlogDetail />} />
                        </Routes>
                    </Elements>
                </main>
                <Footer />
                <ScrollToTopButton />
                {/*<CookieConsentDialog />*/}
                <GeoCookieConsent/>
                {/*<CookieConsent*/}
                {/*    location="bottom"*/}
                {/*    buttonText="Accept"*/}
                {/*    cookieName="userConsent"*/}
                {/*    style={{ background: "#2B373B" }}*/}
                {/*    buttonStyle={{*/}
                {/*        color: "#fff",*/}
                {/*        background: "#8c73ff",*/}
                {/*        fontSize: "14px",*/}
                {/*        padding: "8px 20px",*/}
                {/*        borderRadius: "4px"*/}
                {/*    }}*/}
                {/*    expires={365}>*/}
                {/*    This website uses cookies to enhance the user experience.{" "}*/}
                {/*    <a href="/privacy" style={{ color: "#8c73ff", textDecoration: "underline" }}>*/}
                {/*        Learn more*/}
                {/*    </a>*/}
                {/*</CookieConsent>*/}
            </div>
        </Router>
    );
}

export default App;